import { nb } from '@/i18n/nb';
import type { VedlikeholdStatus } from '@/types/api';
import s from './Vedlikehold.module.css';

// `satisfies` (not a `: Record<…, string>` annotation) because CSS-module class
// access is typed `string | undefined` under noUncheckedIndexedAccess; the union is
// harmless inside the className template literal below.
const STATUS_CLASS = {
  åpen: s.statusOpen,
  tildelt: s.statusAssigned,
  utført: s.statusDone,
  kansellert: s.statusCancelled,
} satisfies Record<VedlikeholdStatus, string | undefined>;

/*
 * Presentational status pill for a Dugnadsoppgave (per dugnad-public-view). A plain
 * <span>, NOT the Chip primitive — Chip is a toggle button (aria-pressed), wrong
 * semantics for a read-only label. The hue lives in the dot so the dark label always
 * clears contrast on its light tinted background (keeps the axe sweep green).
 */
export function StatusBadge({ status }: { status: VedlikeholdStatus }) {
  return (
    <span className={`${s.statusBadge} ${STATUS_CLASS[status]}`}>
      <span className={s.statusDot} aria-hidden="true" />
      <span className={s.statusLabel}>{nb.vedlikehold.dugnad.statusLabel[status]}</span>
    </span>
  );
}
